import { ExerciseTextArea, Vimeo } from "@swizec/gatsby-theme-course-platform";
import * as React from 'react';
export default {
  ExerciseTextArea,
  Vimeo,
  React
};